export const INVOICE_STATUS_META = {
  Draft: { label: "Draft", cls: "border-slate-200 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  Sent: { label: "Sent", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  "Partially Paid": { label: "Partially Paid", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  Paid: { label: "Paid", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  Overdue: { label: "Overdue", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
  Void: { label: "Void", cls: "border-slate-200 text-slate-400 dark:border-white/10 dark:text-slate-500" },
};

export const PAYMENT_METHOD_LABELS = { Cash: "Cash", Check: "Check", ACH: "ACH", Card: "Card", Wire: "Wire", Other: "Other" };

export const formatCents = (cents) => `$${((cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const dollarsToCents = (v) => Math.round((parseFloat(v || 0) || 0) * 100);
export const centsToDollars = (c) => (c == null ? "" : (c / 100).toFixed(2));

export const fmtDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export const todayInputValue = () => new Date().toISOString().slice(0, 10);

export const MILESTONE_TRIGGER_LABELS = {
  immediate: "Immediately upon Proposal acceptance",
  specific_date: "On a specific date",
  job_scheduled: "When the Work Job is scheduled",
  job_started: "When the Work Job starts",
  job_completed: "When the Work Job is completed",
  milestone_reached: "When a defined milestone is reached (manual)",
  manual: "Manual release by staff",
};

export const SCHEDULE_MILESTONE_STATUS_META = {
  Pending: { label: "Pending", cls: "border-slate-200 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  "Ready to Bill": { label: "Ready to Bill", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  Invoiced: { label: "Invoiced", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
};

export const bpToPercent = (bp) => (bp == null ? "" : (bp / 100).toString());
export const percentToBp = (pct) => Math.round((parseFloat(pct || 0) || 0) * 100);

export const blankMilestone = () => ({ label: "", amount_type: "percentage", percentage_bp: 0, amount_cents: 0, trigger_type: "immediate", trigger_date: "" });

export const blankInvoiceRow = () => ({ description: "", quantity: 1, unit_price_cents: 0 });

